import { GOOGLE_MAPS_API_KEY } from "../../Everou/_constants/url.constants";

// Google's JS SDK, loaded on demand — only when someone opens the location
// coordinates dialog, never on app start. It is the client-side route Google
// supports: unlike the Geocoding web service, this one accepts an API key
// restricted by HTTP referrer, which is the only restriction that means anything
// for a key that ships inside the bundle.
//
// env.sh writes the literal "DEFAULT" for any variable the environment does not
// export, so an unset key is that placeholder rather than an empty string.
const READY_CALLBACK = "__everouGoogleMapsReady";

let loadPromise = null;

export const GoogleMapsLoader = {
    hasApiKey,
    loadPlacesLibrary,
};

function hasApiKey() {
    return !!GOOGLE_MAPS_API_KEY && GOOGLE_MAPS_API_KEY !== "DEFAULT";
}

async function loadPlacesLibrary(language = "en") {
    if (!hasApiKey())
        throw new Error("Google Maps API key is not configured");

    if (!loadPromise)
        loadPromise = injectScript(language);

    await loadPromise;

    return window.google.maps.importLibrary("places");
}

function injectScript(language) {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams({
            key: GOOGLE_MAPS_API_KEY,
            libraries: "places",
            language,
            v: "weekly",
            loading: "async",
            callback: READY_CALLBACK,
        });

        window[READY_CALLBACK] = () => resolve();

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
        script.async = true;
        script.onerror = () => {
            // Let a later attempt retry instead of caching the failure forever:
            // this is as likely to be a dropped connection as a bad key.
            loadPromise = null;
            reject(new Error("Google Maps script failed to load"));
        };

        document.head.appendChild(script);
    });
}
